import { CodeBaseModel, CodeStoreFileModel } from '../../api/api';

export type TestArtifactLayer = 'domain' | 'application';

const TEST_TARGET_LAYER_TAG = 'TestTargetLayer';

export function getTestArtifactLayer(
	file: CodeStoreFileModel,
	domainCodebase?: CodeBaseModel | null,
	applicationCodebase?: CodeBaseModel | null,
): TestArtifactLayer {
	const taggedLayer = file.tags.find((tag) => tag.name.toLowerCase() === TEST_TARGET_LAYER_TAG.toLowerCase())?.value?.toLowerCase();
	if (taggedLayer === 'domain' || taggedLayer === 'application') {
		return taggedLayer;
	}

	const searchableText = `${file.namespace}\n${file.content}`.toLowerCase();
	const applicationName = applicationCodebase?.componentName.toLowerCase();
	const domainName = domainCodebase?.componentName.toLowerCase();

	// Application tests commonly reference domain types too, so application wins
	// when both namespaces are present in an older, untagged file.
	if ((applicationName && searchableText.includes(applicationName)) || searchableText.includes('.application')) {
		return 'application';
	}
	if ((domainName && searchableText.includes(domainName)) || searchableText.includes('.domain')) {
		return 'domain';
	}

	// Preserve the previous placement for files that predate layer metadata.
	return 'application';
}
